import { useState, useCallback } from "react";

export function useMutationHandler(apiFn) {
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const [error, setError] = useState(null);

    const mutate = useCallback(
        async (payload) => {
            setIsLoading(true);
            setIsSuccess(false);
            setIsError(false);
            setError(null);

            try {
                const response = await apiFn(payload);
                setIsSuccess(true);
                return response.data;
            } catch (err) {
                setIsError(true);
                setError(err);
                return null;
            } finally {
                setIsLoading(false);
            }
        },
        [apiFn],
    );

    const reset = () => {
        setIsLoading(false);
        setIsSuccess(false);
        setIsError(false);
        setError(null);
    };

    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        reset,
    };
}
